import Vue from 'vue';
import App from './App.vue';
import Notify from './plugins/notification-panel';
import store from './store/store';
import router from './router';
import PortalVue from 'portal-vue';

Vue.config.productionTip = false;

// Notification panel
Vue.use(Notify);
Vue.use(PortalVue);

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import messages from './locales/index';
const i18n = new VueI18n({
  legacy: true,
  locale: 'en',
  messages,
  silentTranslationWarn: true
});

import {library} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

library.add(fas);
Vue.component('awesome-icon', FontAwesomeIcon);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');